import moment from "moment";

/**
 * Validate date range
 * @param {Object} options - Configuration object
 * @param {string} options.fieldName - The name of the field to validate
 * @param {string} options.startDateKey - The name of the start date field
 * @param {string} options.endDateKey - The name of the end date field
 * @param {Date|string} options.startDate - The start date
 * @param {Date|string} options.endDate - The end date
 * @param {string} [options.startErrorText="Start date cannot be after end date"] - The error message to display if the start date is after the end date
 * @param {string} [options.endErrorText="End date cannot be before start date"] - The error message to display if the end date is before the start date
 * @param {boolean} [options.allowSameDay=true] - Whether to allow the start and end dates to be the same
 * @returns {Object} - An object containing any validation errors
 */
export const validateDateRange = ({
  fieldName,
  startDateKey,
  endDateKey,
  startDate,
  endDate,
  startErrorText = "Start date cannot be after end date",
  endErrorText = "End date cannot be before start date",
  allowSameDay = true,
}) => {
  const errors = {};

  if (startDate && endDate) {
    const start = moment(startDate);
    const end = moment(endDate);

    if (allowSameDay) {
      if (end.isBefore(start)) {
        if (fieldName === endDateKey) {
          errors[endDateKey] = endErrorText;
        } else if (fieldName === startDateKey) {
          errors[startDateKey] = startErrorText;
        }
      }
    } else {
      if (end.isBefore(start) || end.isSame(start, "day")) {
        if (fieldName === endDateKey) {
          errors[endDateKey] = endErrorText;
        } else if (fieldName === startDateKey) {
          errors[startDateKey] = startErrorText;
        }
      }
    }
  }

  return errors;
};
